import { jsx as _jsx } from "react/jsx-runtime";
import { KNavBrand } from "./KNavBrand";
import { IMAGES } from "../images";
export const KNavBrandFixed = ({ dark = false, iconPartial, appName }) => {
    return (_jsx(KNavBrand, { icon: dark ? IMAGES[iconPartial].still.small.light : IMAGES[iconPartial].still.small.dark, appName: appName, otherApps: [
            { icon: IMAGES.kopjra.still.small.default, appName: "Store", url: "https://store.kopjra.com" },
            { icon: IMAGES["web-intelligence"].still.small.default, appName: "Web Intelligence", url: "https://webintelligence.kopjra.com" },
            { icon: IMAGES["web-forensics"].still.small.default, appName: "Web Forensics", url: "https://webforensics.kopjra.com" },
            { icon: IMAGES["web-trust"].still.small.default, appName: "Web Trust", url: "https://webtrust.kopjra.com" },
            { icon: IMAGES["web-sign"].still.small.default, appName: "Web Sign", url: "https://app.websign.kopjra.com" },
        ], dark: dark, oaCols: 1 }));
};
